import { AfterViewInit, Component, ElementRef, HostListener, OnDestroy, ViewChild, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalismaDuzeniService, PANEL_GENISLIK } from '../../../services/calisma-duzeni.service';

/** Panel genişliği hazır seçenekleri (px); tutamaçla sürüklenen diğer değerler "özel" görünür. */
const GENISLIKLER = [
  { ad: 'Dar', deger: PANEL_GENISLIK.varsayilan }, // varsayılan (220)
  { ad: 'Normal', deger: 260 },
  { ad: 'Geniş', deger: 340 },
];

/**
 * Görünüm menüsü (18.10.2026): başlıktaki Kompakt anahtarının yanındaki ▾ ile açılır; çalışma düzeni ayarlarının
 * hepsi tek yerde — kompakt düzen, sol menü, açık sekmelerin yeri (üst şerit / sabit panel), panelin yeri ve
 * genişliği, varsayılana dönüş. Durum CalismaDuzeniService'te; paneldeki küçük düğmeler kısayol olarak kalır.
 * Pencere body'ye taşınır (dx-toolbar öğesinin kenarında kesilmesin).
 */
@Component({
  selector: 'dk-gorunum-menusu',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './dk-gorunum-menusu.component.html',
  styleUrls: ['./dk-gorunum-menusu.component.scss'],
})
export class DkGorunumMenusuComponent implements AfterViewInit, OnDestroy {
  readonly duzen = inject(CalismaDuzeniService);
  private host = inject<ElementRef<HTMLElement>>(ElementRef);

  @ViewChild('katman') katman?: ElementRef<HTMLElement>;
  @ViewChild('tetik') tetik?: ElementRef<HTMLButtonElement>;

  readonly genislikler = GENISLIKLER;
  acik = false;
  konum = { top: 0, right: 0 };

  ngAfterViewInit() {
    const k = this.katman?.nativeElement;
    if (k) document.body.appendChild(k);
  }

  ngOnDestroy() {
    this.katman?.nativeElement.remove();
  }

  ozelGenislik(g: number | null): boolean {
    return g != null && !GENISLIKLER.some((x) => x.deger === g);
  }

  ac(olay: Event) {
    olay.stopPropagation();
    if (this.acik) {
      this.acik = false;
      return;
    }
    const r = this.tetik?.nativeElement.getBoundingClientRect();
    if (r) this.konum = { top: Math.round(r.bottom + 6), right: Math.max(8, Math.round(window.innerWidth - r.right)) };
    this.acik = true;
  }

  kapat() {
    this.acik = false;
  }

  varsayilan() {
    this.duzen.varsayilanaDon();
  }

  @HostListener('document:keydown.escape')
  escape() {
    this.acik = false;
  }

  @HostListener('document:mousedown', ['$event'])
  disariBasildi(olay: MouseEvent) {
    if (!this.acik) return;
    const hedef = olay.target as Node | null;
    if (hedef && (this.host.nativeElement.contains(hedef) || this.katman?.nativeElement.contains(hedef))) return;
    this.acik = false;
  }

  @HostListener('window:resize')
  boyut() {
    // ayarlar kendisi resize olayı gönderir; pencere açık kalsın, yalnız konumu tazele
    const r = this.tetik?.nativeElement.getBoundingClientRect();
    if (this.acik && r) this.konum = { top: Math.round(r.bottom + 6), right: Math.max(8, Math.round(window.innerWidth - r.right)) };
  }
}
